export const ПОВАДКИ = {
    // Стоит в засаде, бьёт коротко и мощно. Пасть костистая.
    засадный: {
        windowS: 2.2,
        lipHoldN: 26,
        staminaS: 14,
        strength: 2,
        jumpRate: 0.045,
        speedMps: 0.75,
        speedBandMps: 0.45,
    },
    // Гоняет малька в толще и у поверхности. Губа мягкая, рвётся чаще всех.
    угонщик: {
        windowS: 2,
        lipHoldN: 13,
        staminaS: 9,
        strength: 2.4,
        jumpRate: 0.03,
        speedMps: 1.3,
        speedBandMps: 0.5,
    },
    // Работает дно, берёт медленно и вязко. Пасть держит крючок лучше всех.
    донный_хищник: {
        windowS: 1.8,
        lipHoldN: 30,
        staminaS: 12,
        strength: 1.7,
        jumpRate: 0,
        speedMps: 0.45,
        speedBandMps: 0.3,
    },
    // Мелкая стайная рыба: берёт охотно, сопротивляется недолго.
    стайная_бель: {
        windowS: 2.8,
        lipHoldN: 11,
        staminaS: 5,
        strength: 1.15,
        jumpRate: 0.02,
        speedMps: 0.6,
        speedBandMps: 0.35,
    },
    /*
     * Лещ, густера, синец: высокотелая мирная рыба, которая идёт «фанерой».
     *
     * ⚠️ ЧИСЛА ПОНИЖЕНЫ, И ЭТО ИСПРАВЛЕНИЕ, А НЕ ПОДКРУТКА БАЛАНСА. Стояло
     * «сила 1.9, выносливость 20 с» — числа не леща, а скорее карпа, и эту
     * повадку делили двадцать семь видов, включая обоих. Выходило, что лещ
     * вдвое упорнее, чем должен, а карп вдвое слабее, и главное отличие
     * карповой рыбалки — что карп сопротивляется — просто не существовало.
     *
     * Лещ поднимается почти не упираясь: встал на струю, лёг на бок и вышел.
     * Двадцать секунд боя у восьмисотграммовой рыбы — это про другую рыбу.
     */
    крупная_бель: {
        windowS: 3.2,
        lipHoldN: 15,
        staminaS: 8,
        strength: 1.25,
        jumpRate: 0,
        speedMps: 0.3,
        speedBandMps: 0.2,
    },
    /*
     * Карп, сазан, белый амур, усач, толстолоб: мирные, но силачи.
     *
     * ⚠️ ЭТО НЕ «ЛЕЩ ПОСИЛЬНЕЕ», А ДРУГОЙ БОЙ. Карп на три килограмма уносит
     * полшпули и держит минутами; лещ того же веса выходит за десяток секунд.
     * Числа сняты с карпа при трёх килограммах — он и есть эталон этой повадки.
     */
    карповый_силач: {
        windowS: 3.4,
        lipHoldN: 30,
        staminaS: 34,
        strength: 2.7,
        jumpRate: 0,
        speedMps: 0.25,
        speedBandMps: 0.15,
    },
    // Холодная чистая вода, осторожная подача, резкое сопротивление.
    холодолюбивый: {
        windowS: 1.6,
        lipHoldN: 14,
        staminaS: 10,
        strength: 1.8,
        jumpRate: 0.06,
        speedMps: 0.55,
        speedBandMps: 0.3,
    },
    // Ходит по дну, тянет ровно и долго. Берётся только у грунта.
    осетровый: {
        windowS: 3.5,
        lipHoldN: 34,
        staminaS: 26,
        strength: 2.6,
        jumpRate: 0,
        speedMps: 0.25,
        speedBandMps: 0.15,
    },
    // Мелочь у дна: хватает всё подряд, сопротивления почти нет.
    мелочь: {
        windowS: 3.5,
        lipHoldN: 7,
        staminaS: 3,
        strength: 0.7,
        jumpRate: 0,
        speedMps: 0.4,
        speedBandMps: 0.3,
    },
    // Тропический гигант: держит крючок мёртво, тянет дольше всех и бьёт свечкой
    // при своих ста килограммах. Числа предварительные, как и у прочих повадок.
    тропический_гигант: {
        windowS: 2.8,
        lipHoldN: 40,
        staminaS: 45,
        strength: 3.4,
        jumpRate: 0.02,
        speedMps: 0.5,
        speedBandMps: 0.35,
    },
};
/**
 * Во сколько раз ступень редкости режет частоту поклёвки.
 *
 * ⚠️ ЭТО ЧИСЛА ДЛЯ ДВИЖКА, А НЕ ДЛЯ КРАСОТЫ, И ЛЕСТНИЦА У НИХ КРУТАЯ НАРОЧНО.
 * Каждая ступень примерно втрое реже предыдущей, и от массовой до единичной
 * выходит почти сотня раз. Сделай шаг пологим — редкая рыба перестала бы быть
 * редкой: разница в полтора раза на фоне разброса поклёвок не различается вовсе,
 * и трофей стал бы вопросом усидчивости, а не удачи.
 *
 * ⚠️ ЗДЕСЬ МНОЖИТЕЛЬ, А НЕ ВЕРОЯТНОСТЬ. Он умножается на совпадение вида с
 * местом, приманкой и временем — то есть редкость НЕ заменяет собой правила, а
 * добавляется к ним. Белуга на озёрной отмели не клюнет вовсе, сколько ни
 * сиди: её множитель умножается на ноль от глубины.
 */
export const ЧАСТОТА = {
    массовая: 1,
    обычная: 0.55,
    нечастая: 0.25,
    редкая: 0.1,
    очень_редкая: 0.035,
    единичная: 0.012,
};
//# sourceMappingURL=species-kinds.js.map